import LinkIcon from "@/components/icons/LinkIcon"
import Link from "next/link"

interface CreditsProps {
	credits: any
}

export default function Credits({credits}:CreditsProps) {
	if (!credits?.credits && !credits?.links) return null

	return (
		<div className={`relative credits w-full px-site-margin mt-[6rem] md:mt-[10rem] mb-[6rem] md:mb-[8rem]`}>

			<div className={`relative w-full flex flex-col sm:grid sm:grid-cols-12 gap-gutter justify-between overflow-clip md:gap-gutter sm:before:content-[''] before:absolute before:block before:w-full before:h-[1px] before:bg-black pt-4`}>

				{(credits?.credits && credits?.credits?.length > 0) && (
					<div className="col-span-full sm:col-span-8 md:col-span-9 mb-[4rem] sm:mb-0">
						<h4 className="style-h3 mb-8">Credits</h4>

						<ul className="w-full style-caption flex flex-col gap-3">
							{credits?.credits?.map((credit, index) => (
								<li key={`credit-${index}`} className="grid grid-cols-3 gap-gutter">
									<div className="col-span-1">{credit?.role}</div>
									<div className="col-span-2">
										{credit?.url ? (
											<Link
												className="inline-flex items-center gap-3 sm:gap-4 text-black hover:text-blue"
												href={credit?.url}
												target="_blank">
												<span>{credit?.name}</span>
												<LinkIcon className="block w-3 md:w-4 h-3 md:h-4 mt-[1px]" />
											</Link>
										) : (
											credit?.name
										)}
									</div>
								</li>
							))}
						</ul>
					</div>
				)}

				{(credits?.links && credits?.links?.length > 0) && (
					<div className="col-span-full sm:col-span-4 md:col-span-3 mt-10 sm:mt-0">
						<h4 className="style-h3 mb-8">Links</h4>

						<ul className="style-caption flex flex-col gap-3">
							{credits?.links?.map((link, index) => (
								<li key={`link-${index}`}>
									<Link
										className="inline-flex items-center gap-3 sm:gap-4 text-black hover:text-blue"
										href={link?.url}
										target="_blank">
										<span>{link?.title}</span>
										<LinkIcon className="block w-3 md:w-4 h-3 md:h-4 mt-[1px]" />
									</Link>
								</li>
							))}
						</ul>
					</div>
				)}

			</div>

		</div>
	)
}